import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { listCardsRowConfigShape } from 'app/shapes/browse';
import ListCardsRow from './ListCardsRow';

const ListCardsRowContainer = ({ config }) => {
  const library = useSelector(selectCurrentLibrary);

  return <ListCardsRow config={config} library={library} />;
};

ListCardsRowContainer.propTypes = {
  config: listCardsRowConfigShape.isRequired
};

export default ListCardsRowContainer;
